<form [formGroup]="dealerForm">
    <div class="field-container">
        <mat-form-field>
            <mat-label>Dealer Name</mat-label>
            <input matInput #input required minlength="2" maxlength="100" formControlName="name"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Contact First Name</mat-label>
            <input matInput #input required minlength="2" maxlength="50" formControlName="contactFirstName"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Contact Last Name</mat-label>
            <input matInput #input required minlength="2" maxlength="50" formControlName="contactLastName"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput #input required maxlength="255" formControlName="contactEmail"/>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Phone</mat-label>
            <input matInput #input required maxlength="15" formControlName="contactPhone"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Address Line 1</mat-label>
            <input matInput #input required maxlength="150" formControlName="addressLine1"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Address Line 2</mat-label>
            <input matInput #input required maxlength="150" formControlName="addressLine2"/>
        </mat-form-field><br>
        <mat-form-field>
            <mat-label>Address Line 3</mat-label>
            <input matInput #input maxlength="150" formControlName="addressLine3"/>
        </mat-form-field>
        <app-countries-component (messageEvent)="receiveMessage($event)"/>
    </div>
</form>